<template>
  <div class="handover">
    <div class="page-head-container hotb-detail-page-head">
      <div class="page-head clearfix">
        <div class="page-head-info clearfix">
          <HKLHeader
            link-class-left-primary="link-back-to-tenancy"
            :label-left-primary="hotbHeaderLeftPrimaryLabel"
            :label-left-secondary="hotbHeaderLeftSecondaryLabel"
            :label-right-leading="$t('listNavigation.previousRecord')"
            :label-right-trailing="$t('listNavigation.nextRecord')"
            :navigation-entries="hotbListNavigationEntriesForHeader"
            :nav-base-path-hotb="hotbNavBasePath"
            :nav-base-path-tenant-project="tenantProjectNavBasePath"
            :current-record-id="$route.params.id"
            @left-primary="navTo(tenancyId)"
            @left-secondary="navToAllTenantProjects"
            @right-leading="onHklListNavEntry"
            @right-trailing="onHklListNavEntry"
          />
          <div class="row clearfix hotb-title-row">
            <div
              :title="title"
              class="title page-hotb-description"
            >
              <span>{{ title }}</span>
              <div class="options-wrapper">
                <PageHeaderOptions
                  v-hkldreset
                  class="options"
                  :showSubstitute="allowResetToDraft || allowComplete"
                  :allowChangePIC="allowChangePIC"
                  :allowCancel="allowCancel"
                  :previousPersonInCharge="currentPersonInCharge"
                  :confirmCancelMsg="$t('hint.cancelHandover')"
                  :getSelectedList="getSelectedList"
                  @change-pic="val=>changePIC(val)"
                  @cancelItem="cancelHandover()"
                >
                  <li slot="substitute">
                    <DialogSlot
                      v-if="allowResetToDraft"
                      id="hotb-reset-to-draft-dialog"
                      ref="resetToDraft"
                      :modalBtnClass="'btn--transparent'"
                      :modalBtn="$t('action.resetToDraft')"
                    >
                      <div
                        slot="content"
                        class="font-bold"
                      >
                        <span>{{ $t('hint.resetHotbToDraft') }}</span>
                      </div>
                      <div slot="buttons">
                        <button
                          v-hkldreset
                          type="button"
                          class="btn btn--orange close-reveal-modal"
                          @click="resetHotbToDraft()"
                        >{{ $t('action.yesContinue') }}</button>
                      </div>
                    </DialogSlot>
                    <button
                      v-if="allowComplete"
                      class="btn--transparent"
                      @click="initCompleteHotbModel()"
                    >
                      {{ $t('action.notifyComplete') }}
                    </button>
                  </li>
                </PageHeaderOptions>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="handover-takeback-content">
      <TabsContainer
        :tabNames="isTenant ? tenantTabNames : tabNames"
        :class="isTenant ? 'tenant-view-tab-width' : ''"
        :extendStyleA="extendStyleA"
      >
        <HandoverTakebackInformation
          :slot="tabsContainerIdMap.HOTBINFO"
          :tabsContainerIdMap="tabsContainerIdMap"
          :allowEdit="allowEditInfo"
          :allowApprove="allowApprove"
          :isWappr="isWappr"
          :isSpecial="isSpecial"
          :allowInvite="allowArrange"
          :allowEditDocs="allowEditDocs"
        />
        <HandoverTakebackSchedule
          v-if="!isTenant"
          ref="hotbSchedule"
          :slot="tabsContainerIdMap.HOTBSCHEDULE"
          :allowEdit="allowEditOthers"
          :allowGeneratePdf="allowGeneratePdf"
        />
        <KeySchedule
          v-if="!isTenant"
          :slot="tabsContainerIdMap.HOTBKEYSCHEDULE"
          :allowEdit="allowEditOthers"
          :allowGeneratePdf="allowGeneratePdf"
        />
        <AttachmentsForTenant
          ref="attachmentsForTenant"
          :slot="tabsContainerIdMap.HOTBATTACHMENTTOTENANT"
          :allowEdit="allowEditDocsToTenant"
          :isWappr="isWappr"
        />
      </TabsContainer>
    </div>

    <div
      :id="hotbCompleteModelId"
      class="reveal hotb-complete-model"
    >
      <div class="complete-title required-flag">
        {{ $t('action.notifyComplete') }}
      </div>
      <div class="hotb-complete-type-group">
        <div class="radio">
          <input
            :id="signedRadioBtnId"
            v-model="signedDocUploaded"
            type="radio"
            name="hotb-complete-type"
            :value="true"
          >
          <label
            class="emphasis"
            :for="signedRadioBtnId"
          >
            {{ $t('handover.complete.signedDocsUploaded') }}
          </label>
        </div>
        <div class="radio">
          <input
            :id="unsignedRadioBtnId"
            v-model="signedDocUploaded"
            type="radio"
            name="hotb-complete-type"
            :value="false"
          >
          <label
            class="emphasis"
            :for="unsignedRadioBtnId"
          >
            {{ $t('handover.complete.unsignedDocsUploaded') }}
          </label>
        </div>
      </div>

      <div
        class="complete-attachments"
        :class="!completeDocUploaded ? 'error-highlight' : ''"
      >
        <div class="complete-attachments-label required-flag">
          {{ $t('handover.completeAttachments') }}
        </div>
        <HkldDropzone
          v-if="true"
          ref="hotbCompleteDropZone"
          :sourceId="deep(currentHotb, 'pubDocResourceId') || ''"
        />
        <EditAttachments
          ref="hotbCompleteAttachments"
          class="complete-edit-attachments"
          :sourceId="deep(currentHotb, 'pubDocResourceId') || ''"
          :canEdit="false"
          :isShowDes="false"
          :canDelete="true"
          :isShowUploadedDate="false"
          :canDownloadAll="false"
          :hiddenAttachments="hiddenAttachments"
        />
      </div>
      <div class="complete-date-label required-flag">
        {{ isHandover ? $t('handover.actualHandoverDate') : $t('handover.actualTakebackDate') }}
      </div>
      <DatePicker
        format="DD MMM YYYY"
        :clearButton="false"
        :calendarButton="true"
        calendarButtonIcon="fa fa-calendar"
        :value="completedDate"
        @selected="val => updateCompleteDate(val)"
      />
      <div class="complete-btn-group">
        <button
          class="btn--darkblue"
          @click="cancelCompleteHotb()"
        >
          {{ $t('action.cancel') }}
        </button>
        <button
          class="btn--orange"
          @click="complete()"
        >
          {{ $t('action.confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DatePicker from '@/controls/DatePicker'
import DialogSlot from '@/controls/DialogSlot'
import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'
import HKLHeader from '@/controls/HKLHeader'
import PageHeaderOptions from '@/modules/PageHeaderOptions'
import TabsContainer from '@/controls/TabsContainer'
import { LIST_NAV_KIND, mergeListNavigationHeaderPaths, pushListNavigationEntry, resolveNavigationKind } from '@/constants/listNavigation'
import { tenantProjectRouteNames, tenancyRecordsRouteNames } from '@/constants/router'
import { VIEW_ALL_RESUME_SEARCH_QUERY } from '@/constants/viewAllTableCache'
import EventBus from '@/utils/eventBus'
import navigation from '@/utils/navigation'
import mutationTypes from '@/store/mutation-types'
import userHelper from '@/utils/userHelper'
import { getSameBuildingUsersByPermission } from '@/api/users/request'
import { aclHelper, tmsPermsTypes, PermTypeMapKeys } from '@/utils/aclHelper'
import { ActionTypes, EmailTypes, tenancyViewTabs } from '@/utils/consts'
import { getAttachments, deleteDocument } from '@/api/docs/request'
import { hotbStatus, hotbAttrTypes } from '@/utils/locale'
import { sendEmail } from '@/api/postman/request'
import { utils as formUtils } from '@/plugin/InputChange'
import KeySchedule from './KeySchedule'
import HandoverTakebackSchedule from './HandoverTakebackSchedule'
import HandoverTakebackInformation from './HandoverTakebackInformation'
import AttachmentsForTenant from './AttachmentsForTenant'
import { getHotbTradeName, getHotbPremises } from './utils'
import store from '@/store'

/** Match TenantProject: dashboard → HOTB without View All list — HKL + “View Tenancy Record” (no plain Back before load). */
const HOTB_DASHBOARD_ENTRY_ROUTE_NAMES = new Set([
  'engineerDashboard',
  'home',
  'tenantDashboard',
])

/** Dashboard or returning from tenancy detail (browser Back) — same “tenancy-only” header when no global list. */
const HOTB_TENANCY_ONLY_ENTRY_ROUTE_NAMES = new Set([
  ...HOTB_DASHBOARD_ENTRY_ROUTE_NAMES,
  tenancyRecordsRouteNames.ccdTenancyView,
  tenancyRecordsRouteNames.ccdTenancyTenantView,
])

function isHandoverDashboardLikeEntry (fromRoute) {
  const n = fromRoute && fromRoute.name
  return n != null && n !== '' && HOTB_DASHBOARD_ENTRY_ROUTE_NAMES.has(String(n))
}

/** Prev/next only when sequence came from global lists or in-flow prev/next — not TenancyView “All Projects” tab (`suppressSecondaryBackToSearchResults`). */
const ROUTE_NAMES_PRESERVE_HOTB_LIST_NAV = new Set([
  tenantProjectRouteNames.handover,
  tenantProjectRouteNames.tenantHandover,
  tenantProjectRouteNames.tenantProject,
  tenantProjectRouteNames.tenantProjectDetail,
  tenantProjectRouteNames.editTenantProject,
  tenantProjectRouteNames.createTenantProject,
  tenantProjectRouteNames.allTenantProjects,
  tenancyRecordsRouteNames.ccdTenancyView,
  tenancyRecordsRouteNames.ccdTenancyTenantView,
])

function clearStaleHotbListNavigationIfUnanchoredEnter (fromRoute) {
  const fromName = fromRoute && fromRoute.name
  if (fromName != null && fromName !== '' && ROUTE_NAMES_PRESERVE_HOTB_LIST_NAV.has(String(fromName))) {
    return
  }
  const seq = store.getters['listNavigation/listNavigationSequence'] || []
  if (!seq.length) return
  const allHotbOrTenantProject = seq.every((e) => {
    const k = resolveNavigationKind(e)
    return k === LIST_NAV_KIND.HOTB || k === LIST_NAV_KIND.TENANT_PROJECT
  })
  if (!allHotbOrTenantProject) return
  store.dispatch('listNavigation/clearListNavigationSequence')
}

export default {
  components: {
    AttachmentsForTenant,
    DatePicker,
    DialogSlot,
    HKLHeader,
    EditAttachments,
    HkldDropzone,
    HandoverTakebackInformation,
    HandoverTakebackSchedule,
    KeySchedule,
    PageHeaderOptions,
    TabsContainer,
  },
  beforeRouteEnter (to, from, next) {
    if (isHandoverDashboardLikeEntry(from)) {
      store.dispatch('listNavigation/clearListNavigationSequence')
    }
    clearStaleHotbListNavigationIfUnanchoredEnter(from)
    const fromName = from && from.name != null ? String(from.name) : ''
    next((vm) => {
      vm.hotbHeaderEntryFrom = fromName
    })
  },
  beforeRouteUpdate (to, from, next) {
    if (String(to.params.id) !== String(from.params.id)) {
      this.hotbHeaderEntryFrom = from && from.name != null ? String(from.name) : ''
    }
    next()
  },
  data () {
    return {
      currentTab: 0,
      extendStyleA: {
        background: 'white',
        fontSize: '16px',
        fontWeight: 'bold',
        fontFamily: 'Verdana',
        height: '44px',
        padding: '0',
        lineHeight: '44px',
        width: '100%',
      },
      deep,
      completedDate: null,
      signedDocUploaded: false,
      completeDocUploaded: true,
      tabsContainerIdMap: {
        HOTBINFO: 'tab-0',
        HOTBSCHEDULE: 'tab-1',
        HOTBKEYSCHEDULE: 'tab-2',
        HOTBATTACHMENTTOTENANT: 'tab-3',
      },
      attachmentsBeforeCompeleteModel: [],
      hotbCompleteModelId: `hotbCompleteModel-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`,
      signedRadioBtnId: `hotb-complete-type-signed-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`,
      unsignedRadioBtnId: `hotb-complete-type-unsigned-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`,
      boundDropzonePubDocId: null,
      /** Predecessor route `name` (beforeRouteEnter / beforeRouteUpdate) for dashboard / tenancy-return header. */
      hotbHeaderEntryFrom: '',
    }
  },
  computed: {
    ...mapGetters('user', ['isTenant', 'currentUser', 'isAdmin']),
    ...mapGetters('hotb', ['currentHotb', 'isHandover']),
    ...mapGetters('listNavigation', ['listNavigationSequence', 'suppressSecondaryBackToSearchResults']),
    title () {
      const building = lodash.get(this.currentHotb, 'tenancy.building.code', '')
      const premises = lodash.get(this.currentHotb, 'premises') || getHotbPremises(this.currentHotb) || this.$t('emptyValue')
      const tradeName = lodash.get(this.currentHotb, 'tradeName') || getHotbTradeName(this.currentHotb)
      return `${tradeName}/${this.$t(this.isHandover ? 'handover.handoverTitle' : 'takeback.takebackTitle', [building ? (building + ' ' + premises) : premises])}`
    },
    personInChargeName () {
      let username
      if (this.isWappr) {
        username = deep(this.currentHotb, 'approver.username')
      }
      if (this.isDraft || this.isRejected) {
        username = deep(this.currentHotb, 'manager.username')
      }
      return username
    },
    currentPersonInCharge () {
      let displayName
      if (this.isWappr) {
        displayName = deep(this.currentHotb, 'approver.displayName')
      }
      if (this.isDraft || this.isRejected) {
        displayName = deep(this.currentHotb, 'manager.displayName')
      }
      return `${userHelper.getUserName(this.personInChargeName, displayName)} (${this.personInChargeName})`
    },
    tabNames () {
      const handoverTabsName = [
        this.$t('handover.nav.handoverInfor'),
        this.$t('handover.nav.handoverSchedule'),
        this.$t('handover.nav.keyHandover'),
        this.$t('handover.attachmentsForTenant'),
      ]
      const takeoverTabsName = [
        this.$t('takeback.nav.takebackInfor'),
        this.$t('takeback.nav.takebackSchedule'),
        this.$t('takeback.nav.keyTakeback'),
        this.$t('handover.attachmentsForTenant'),
      ]
      return this.isHandover ? handoverTabsName : takeoverTabsName
    },
    tenantTabNames () {
      return this.isHandover ? [this.$t('handover.nav.handoverInfor')] : [this.$t('takeback.nav.takebackInfor')]
    },
    tenancyId () {
      return lodash.get(this.currentHotb, 'tenancy.id', '')
    },
    hotbNavBasePath () {
      return this.isTenant ? '/tenants/handover-takeback' : '/handover-takeback'
    },
    tenantProjectNavBasePath () {
      return this.isTenant ? '/tenants/tenant-projects' : '/tenant-projects'
    },
    /**
     * Entries for HKL prev/next: hidden when list was committed from TenancyView “All Projects”
     * (`suppressSecondaryBackToSearchResults`, same as TenantProject.vue).
     */
    hotbListNavigationEntriesForHeader () {
      if (this.suppressSecondaryBackToSearchResults) return []
      const seq = this.listNavigationSequence || []
      const cur = String(this.$route.params.id || '')
      if (!Array.isArray(seq) || !seq.length || !cur) return []
      if (!seq.some(e => String(e.id) === cur)) return []
      return seq
    },
    /** True when header should show prev/next (anchored sequence, not tenancy-tab-only). */
    hasListNavigationSequence () {
      return this.hotbListNavigationEntriesForHeader.length > 0
    },
    /**
     * Dashboard → handover, or browser Back from tenancy detail: no View All list — “tenancy-only” header
     * (no plain Back before load when no `tenancyId`). `suppressSecondaryBackToSearchResults` excludes embed tab.
     */
    showHotbTenancyOnlyHeader () {
      if (this.suppressSecondaryBackToSearchResults) return false
      if (this.hasListNavigationSequence) return false
      const hid = String(this.$route.params.id || '')
      if (!hid) return false
      const fromName = this.hotbHeaderEntryFrom
      if (!fromName || !HOTB_TENANCY_ONLY_ENTRY_ROUTE_NAMES.has(fromName)) return false
      return !!(this.tenancyId || this.$route.params.id)
    },
    /** Primary: always “View Tenancy Record” (replace plain Back). */
    hotbHeaderLeftPrimaryLabel () {
      return this.$t('handover.backToTenancy')
    },
    /** “Back to search results” only when user arrived from a committed global list sequence (prev/next visible). */
    hotbHeaderLeftSecondaryLabel () {
      if (!this.hasListNavigationSequence) return ''
      return this.$t('listNavigation.backToSearchResults')
    },
    hklListNavMergedPaths () {
      return mergeListNavigationHeaderPaths({}, this.hotbNavBasePath, this.tenantProjectNavBasePath)
    },
    isDraft () {
      return this.currentHotb && hotbStatus.DRAFT === this.currentHotb.status
    },
    isRejected () {
      return this.currentHotb && hotbStatus.REJECTED === this.currentHotb.status
    },
    isWappr () {
      return this.currentHotb && hotbStatus.WAPPR === this.currentHotb.status
    },
    isAppr () {
      return this.currentHotb && hotbStatus.APPR === this.currentHotb.status
    },
    isScheduled () {
      return this.currentHotb && hotbStatus.SCHEDULED === this.currentHotb.status
    },
    isUnsigned () {
      return this.currentHotb && hotbStatus.UNSIGNED === this.currentHotb.status
    },
    isCompleted () {
      return this.currentHotb && hotbStatus.COMPLETED === this.currentHotb.status
    },
    isCancelled () {
      return this.currentHotb && hotbStatus.CANCELLED === this.currentHotb.status
    },
    isApprover () {
      return this.currentHotb && this.currentHotb.approvedBy === this.currentUser.id
    },
    allowEditInfo () {
      return (this.isDraft || this.isRejected) && (this.currentHotb.managedBy === this.currentUser.id)
    },
    allowApprove () {
      return this.isWappr && aclHelper.getAccess(tmsPermsTypes.hotb.approve) && this.isApprover
    },
    isManager () {
      return this.currentHotb.managedBy === this.currentUser.id
    },
    allowEditDocs () {
      const enabledForPic = this.isDraft && this.isManager
      const allowStatus = !this.isCancelled && !this.isCompleted && !this.isDraft
      return (allowStatus && aclHelper.hasUpdateHotbAccess()) || enabledForPic
    },
    allowEditDocsToTenant () {
      const enabledForPic = this.isDraft && this.isManager
      const allowStatus = !this.isCancelled && !this.isDraft
      return (allowStatus && aclHelper.hasUpdateHotbAccess()) || enabledForPic
    },
    allowEditOthers () {
      const isAllowedStatus = this.currentHotb &&
        [hotbStatus.APPR, hotbStatus.SCHEDULED, hotbStatus.UNSIGNED, hotbStatus.COMPLETED].includes(this.currentHotb.status)
      return isAllowedStatus && aclHelper.getAccess(tmsPermsTypes.hotb.update)
    },
    allowGeneratePdf () {
      const isAllowedStatus = this.currentHotb &&
        [hotbStatus.APPR, hotbStatus.SCHEDULED, hotbStatus.UNSIGNED, hotbStatus.COMPLETED].includes(this.currentHotb.status)
      return isAllowedStatus && aclHelper.getAccess(tmsPermsTypes.hotb.update)
    },
    allowArrange () {
      return (this.isAppr || this.isScheduled) && aclHelper.getAccess(tmsPermsTypes.hotb.arrange)
    },
    canChangePIC () {
      return aclHelper.getAccess(tmsPermsTypes.hotb.changePIC)
    },
    allowChangePIC () {
      return (this.isDraft || this.isWappr || this.isRejected) && (this.canChangePIC || this.isAdmin)
    },
    allowCancel () {
      const createHoAccess = aclHelper.getAccess(tmsPermsTypes.hotb.create)
      return createHoAccess && this.isPIC && (this.isDraft || this.isRejected)
    },
    isPIC () {
      return this.personInChargeName === this.currentUser.username
    },
    isSpecial () {
      const transactionDate = lodash.get(this.currentHotb, 'transactionDate', '')
      // to handle transaction date and submit date is the same day, but still could arrange
      let submittedDate = lodash.get(this.currentHotb, 'submittedDate', '')
      submittedDate = submittedDate ? new Date(submittedDate) : ''
      const noTimeSubmittedDate = submittedDate ? new Date(submittedDate.getFullYear(), submittedDate.getMonth(), submittedDate.getDate()) : ''
      return noTimeSubmittedDate && (noTimeSubmittedDate > new Date(transactionDate))
    },
    allowComplete () {
      return (this.isAppr || this.isScheduled || this.isUnsigned) && aclHelper.getAccess(tmsPermsTypes.hotb.update)
    },
    canResetToDraft () {
      return aclHelper.getAccess(tmsPermsTypes.hotb.resetToDraft) || this.isAdmin
    },
    allowResetToDraft () {
      return (this.isWappr || this.isAppr || this.isScheduled) && this.canResetToDraft
    },
    hiddenAttachments () {
      return this.attachmentsBeforeCompeleteModel
    },
    transactionDate () {
      return lodash.get(this.currentHotb, 'transactionDate', '')
    },
  },
  watch: {
    transactionDate () {
      this.completedDate = this.getCompletedDate()
    },
    '$route.params.id': {
      async handler (newId, oldId) {
        if (newId == null || String(newId) === String(oldId)) return
        this.unbindHotbDropzoneListener()
        await this.loadHotb(newId)
        this.syncListNavigationSequenceWithRoute()
        this.completedDate = this.getCompletedDate()
        await this.$nextTick()
        if (this.$refs.hotbSchedule) {
          await this.$refs.hotbSchedule.initSchedule()
        }
        this.bindHotbDropzoneListener()
      },
    },
  },
  beforeMount () {
    this.clearHotb()
    if (this.$router.currentRoute.params.type) {
      this.setHotbType(this.$router.currentRoute.params.type.toUpperCase())
    }
  },
  async mounted () {
    await this.loadHotb(this.$route.params.id)
    await this.$store.dispatch('listNavigation/suspendTenancyRecordSequenceIfPresent', {
      tenancyId: this.tenancyId,
    })
    this.syncListNavigationSequenceWithRoute()
    this.completedDate = this.getCompletedDate()
    if (this.$refs.hotbSchedule) {
      await this.$refs.hotbSchedule.initSchedule()
    }
    this.bindHotbDropzoneListener()
  },
  methods: {
    ...mapActions('hotb', ['clearHotb', 'setHotbType', 'loadHotb', 'patchStatus', 'updateHotb']),
    ...mapActions('listNavigation', ['clearListNavigationSequence']),
    ...mapMutations('hotb', {
      updateFieldByPath: mutationTypes.HOTB_UPDATE_FIELD_PATH,
    }),

    navTo (id) {
      if (id == null || id === '') return
      const routerName = !this.isTenant ? 'ccdTenancyView' : 'ccdTenancyTenantView'
      navigation.toPage(routerName, { id })
    },

    navToAllTenantProjects () {
      if (this.isTenant) {
        const id = this.tenancyId
        if (id) {
          navigation.toPage('ccdTenancyTenantView', { id }, { tabIndex: tenancyViewTabs.allProjects })
        }
      } else {
        navigation.toPage('allTenantProjects', {}, { [VIEW_ALL_RESUME_SEARCH_QUERY]: '1' })
      }
    },

    onHklListNavEntry (entry) {
      pushListNavigationEntry(this.$router, this.$route, this.hklListNavMergedPaths, entry)
    },

    syncListNavigationSequenceWithRoute () {
      const cur = String(this.$route.params.id)
      const seq = this.listNavigationSequence || []
      if (seq.length && !seq.some(e => String(e.id) === cur)) {
        this.clearListNavigationSequence()
      }
    },

    onHotbDropzoneNewItem () {
      this.completeDocUploaded = true
    },
    unbindHotbDropzoneListener (pubDocId) {
      const id = pubDocId != null ? pubDocId : this.boundDropzonePubDocId
      if (id) {
        EventBus.$off(`controls.hkldDropzone.newItem.${id}`, this.onHotbDropzoneNewItem)
      }
      if (pubDocId == null) {
        this.boundDropzonePubDocId = null
      }
    },
    bindHotbDropzoneListener () {
      this.unbindHotbDropzoneListener()
      const pubDocId = lodash.get(this.currentHotb, 'pubDocResourceId')
      if (pubDocId) {
        EventBus.$on(`controls.hkldDropzone.newItem.${pubDocId}`, this.onHotbDropzoneNewItem)
        this.boundDropzonePubDocId = pubDocId
      }
    },

    async cancelHandover () {
      await this.patchStatus({
        request: { status: hotbStatus.CANCELLED },
        action: ActionTypes.hotb.cancel,
      })
      formUtils.resetDirty()
      await this.loadHotb(this.currentHotb.id)
    },

    updateCompleteDate (val) {
      this.completedDate = val
    },

    getCompletedDate () {
      const completeDate = lodash.get(this.currentHotb, 'completedDate', '') || this.transactionDate
      return completeDate ? new Date(completeDate) : new Date()
    },

    async getSelectedList () {
      let users
      const tenancy = lodash.get(this.currentHotb, 'tenancy', '')
      let perm
      if (this.currentHotb.status === hotbStatus.WAPPR) {
        perm = PermTypeMapKeys.HOTB_APPROVE
      } else {
        perm = PermTypeMapKeys.HOTB_CREATE_CANCEL
      }
      users = await getSameBuildingUsersByPermission({
        buildingId: tenancy.building.id,
        tenancyId: tenancy.id,
        tenancyType: tenancy.type,
        includeSelf: false,
        permTypes: perm,
      })
      users = users.sort((a, b) => a.name.localeCompare(b.name))
      return users.reduce((partialData, user) => {
        const displayPicName = `${user.name} (${user.username})`
        const filteredUsers = { ...partialData }
        filteredUsers[displayPicName] = user

        return filteredUsers
      }, {})
    },

    async changePIC (newPIC) {
      const action = ActionTypes.hotb.changePIC
      const updatePath = this.isWappr ? 'approvedBy' : 'managedBy'
      this.updateFieldByPath({path: [updatePath], newValue: newPIC.id})
      await this.updateHotb({attrs: [updatePath], action: action})
      await this.loadHotb(this.currentHotb.id)
      if (this.isWappr) {
        const hotbType = hotbAttrTypes[this.currentHotb.type]
        sendEmail(EmailTypes[hotbType].submitForApproval)
      }
    },

    async initCompleteHotbModel () {
      this.completeDocUploaded = true
      this.attachmentsBeforeCompeleteModel = await getAttachments(this.currentHotb.pubDocResourceId)
      if (!this.completehotbModel) {
        this.completehotbModel = await new Foundation.Reveal($(`#${this.hotbCompleteModelId}`), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.completehotbModel.open()
    },
    async getCompleteNewUploadDocs () {
      const files = await getAttachments(this.currentHotb.pubDocResourceId)
      let beforeIds = []
      if (this.attachmentsBeforeCompeleteModel.length > 0) {
        beforeIds = this.attachmentsBeforeCompeleteModel.map(item => item.id)
      }
      const result = files.filter((item) => beforeIds.indexOf(item.id) === -1)
      return result
    },
    async cancelCompleteHotb () {
      this.completedDate = this.getCompletedDate()
      const newUploadDocs = await this.getCompleteNewUploadDocs()
      await Promise.all(newUploadDocs.map(async item => {
        await deleteDocument(item.id, {})
      }))
      this.completeDocUploaded = true
      this.$refs.hotbCompleteDropZone.resetMessages()
      await this.$refs.attachmentsForTenant.forceLoadAttachments()
      if (this.completehotbModel) {
        this.completehotbModel.close()
      }
    },

    async complete () {
      const newUploadDocs = await this.getCompleteNewUploadDocs()
      if (!newUploadDocs.length) {
        this.completeDocUploaded = false
        return
      }
      const hotbType = hotbAttrTypes[this.currentHotb.type]
      this.updateFieldByPath({ path: ['completedDate'], newValue: this.completedDate })
      await this.updateHotb({attrs: ['completedDate']})
      if (this.signedDocUploaded) {
        await this.patchStatus({
          request: { status: hotbStatus.COMPLETED },
          action: ActionTypes.hotb.complete,
        })
        sendEmail(EmailTypes[hotbType].complete, { docIds: newUploadDocs.map(item => item.id) })
      } else {
        await this.patchStatus({
          request: { status: hotbStatus.UNSIGNED },
          action: ActionTypes.hotb.notifyUnsigned,
        })
        sendEmail(EmailTypes[hotbType].unsigned, { docIds: newUploadDocs.map(item => item.id) })
      }
      this.loadHotb(this.currentHotb.id)
      if (this.$refs.hotbCompleteDropZone) {
        this.$refs.hotbCompleteDropZone.resetMessages()
      }
      await this.$refs.attachmentsForTenant.forceLoadAttachments()
      if (this.completehotbModel) {
        this.completehotbModel.close()
      }
    },
    async resetHotbToDraft () {
      await this.patchStatus({
        request: { status: hotbStatus.DRAFT },
        action: ActionTypes.hotb.resetToDraft,
      })
      this.loadHotb(this.currentHotb.id)
      this.$refs.resetToDraft.closeModal()
    },
  },
  beforeDestroy () {
    if (this.completehotbModel) {
      this.completehotbModel.destroy()
      delete this.completehotbModel
      $(`#${this.hotbCompleteModelId}`).remove()
    }

    this.unbindHotbDropzoneListener()
  },
}
</script>

<style lang="scss" scoped>
.options-wrapper {
  display: inline-block;
}

.error-highlight {
  background-color: #f9ecea;
}
</style>

<style lang="scss">
.handover {
  height: 100%;
  background: #ebebeb;

  /* Align with tenancy / TMS: single white header card wrapping HKL + title */
  .hotb-detail-page-head.page-head-container {
    width: 100%;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(172, 172, 172, 0.5);
    padding: 15px 15px 22px;

    .page-head {
      max-width: calc(1440px - 30px);
      margin: 0 auto;
      padding: 0;
      position: relative;
    }

    .page-head-info {
      width: 100%;
    }

    .hotb-header-plain-back {
      cursor: pointer;
      font-family: Verdana;
      font-size: 14px;
      color: #0c3a58;
      display: inline-block;
      margin-top: 5px;
      margin-bottom: 5px;
    }

    .hotb-title-row .title {
      padding-bottom: 24px;
      text-overflow: ellipsis;
      font-family: Georgia;
      font-size: 24px;
      color: #0c2b46;
    }
    .hotb-title-row .back {
      cursor: pointer;
      font-family: Verdana;
      font-size: 14px;
      width: 60px;
      color: #0C3A58;
      margin-bottom: 10px;
    }

    .options {
      line-height: 1;
      .dropdown.menu.tender-dropdown{
        display: inline;
        margin: 0;
        line-height: 40px;
      }
      .is-dropdown-submenu-parent {
        line-height: 1;
        vertical-align: baseline;
        .mouse-over-finger {
          vertical-align: middle;
        }
      }
      .btn--transparent {
        background-color: #33698f;
        width: 100%;
      }
      .tender-ellipsis-bg {
        border-width: 0;
      }
      #tender-ellipsis-bg-page-header-options {
        z-index: 110;
      }
    }
  }

  .tabs-container {
    padding: 15px;
    .tabs-panel {
      background: white;
      padding: 1rem;
    }
    .tabs-title {
      width: 33%;
    }
    li:first-child {
      max-width: 352px;
    }
  }

  .handover-takeback-content {
    max-width: 1440px;
    margin: 0 auto;
    padding: 15px;
    & > div {
      height: 100%;
      background: white;
    }
  }

  #common-tabs {
    margin-bottom: 2px;
    box-shadow: 0 2px 4px 0 rgba(234,234,234,0.50);
    li {
      max-width: 352px;
      box-shadow: 0 0px 4px 0 rgba(234,234,234,0.50);
    }
  }
  div.tabs-panel {
    padding: 20px 24px;
     background: white;
  }
}

.hotb-complete-model {
  width: 500px;
  .complete-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .complete-attachments {
    padding: 5px;
  }
  .complete-date-label, .complete-attachments-label {
    font-weight: bold;
    height: 20px;
    margin-bottom: 5px;
  }
  .complete-edit-attachments {
    margin-top: 15px;
    .filename {
      width: 85%;
    }
  }
  .complete-btn-group {
    margin-top: 20px;
    text-align: right;
  }
  .hotb-complete-type-group {
    margin-bottom: 12px;
    label {
      color: #0c3a58;
    }
  }
}
</style>
